import { IconStatus } from '../components/CouponDialogIcon/CouponDialogIcon';

import { CouponStatus } from './determineStatus';

const determineIconStatus = (status: CouponStatus): IconStatus => {
    if (status === 'error') {
        return 'invalid';
    }

    if (status === 'applied' || status === 'validated') {
        return 'applied';
    }

    return 'default';
};

export default determineIconStatus;
